// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__11ZtM","rootSuccess":"CompleteLink_rootSuccess__2fPQg","rootFailure":"CompleteLink_rootFailure__11t_K","isDisabled":"CompleteLink_isDisabled__yYOgo"};